<script>
export default {
  props: {
    selectedCountry: Object,
    cityNameFilter: Array,
    artTypeFilter:  Array,
    specialityFilter: Array,
    genreFilter: Array,
  },
  data() {
    return {
      countryName: this.selectedCountry?.name,
      countrySlug: this.selectedCountry?.slug,
      cityName: this.cityNameFilter,
      artType: this.artTypeFilter,
      speciality: this.specialityFilter,
      genre: this.genreFilter,
      queryData: {},
      breadcrumbsData: [],
    }
  },
  mounted() {
    this.onCountryChange();
    this.makeBreadCrumbsData();
    window.addEventListener("storage", this.onCountryChange)
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onCountryChange)
  },
  methods: {
    onCountryChange() {
      let countryName, countrySlug;
      if ((countryName = localStorage.getItem('country_name'))) {
        this.countryName = countryName;
      }
      this.makeBreadCrumbsData();
    },
    getSlug(type, slugField = 'slug') {
      return this.queryData[type]?.map(i => `${i[slugField]}`?.toLowerCase()).join(',');
    },
    makeUrl(type, addCountry) {
      let url = ['/discover'];
      if(addCountry) {
        url.push(this.countrySlug);
      }

      switch (type) {
        case 'city':
          if (this.getSlug('cityNameFilter', 'slugName')) {
            url.push(this.getSlug('cityNameFilter', 'slugName'));
          }
          break;
        case 'art_type':
          if (this.getSlug('cityNameFilter', 'slugName')) {
            url.push(this.getSlug('cityNameFilter', 'slugName'));
          }
          url.push(this.getSlug('artTypeFilter'));
          break;
        case 'speciality':
          if (this.getSlug('cityNameFilter', 'slugName')) {
            url.push(this.getSlug('cityNameFilter', 'slugName'));
          }
          url.push(this.getSlug('artTypeFilter'));
          url.push(this.getSlug('specialityFilter'));
          break;
        case 'genre':
          if (this.getSlug('cityNameFilter', 'slugName')) {
            url.push(this.getSlug('cityNameFilter', 'slugName'));
          }
          url.push(this.getSlug('artTypeFilter'));
          if (this.getSlug('specialityFilter')) {
            url.push(this.getSlug('specialityFilter'));
          }
          url.push(this.getSlug('genreFilter'));
      }

      return url.join('/');
    },
    updateData(newData) {
      this.cityName = newData.cityNameFilter.map(i => i.name);
      this.artType = newData.artTypeFilter.map(i => i.name);
      this.speciality = newData.specialityFilter.map(i => i.name);
      this.genre = newData.genreFilter.map(i => i.name);
      this.countrySlug = newData.countrySlug;
      this.queryData = newData;
      this.makeBreadCrumbsData();
    },
    updateSchema() {
      const scriptId = 'breadcrumbs-data-list';
      let scriptElement = document.getElementById(scriptId);
      if (!scriptElement) {
        scriptElement =  document.createElement('script');
        scriptElement.type = 'application/ld+json';
        scriptElement.id = scriptId;
        document.head.appendChild(scriptElement);
      }

      const { protocol, hostname, port } = window.location;
      const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;

      const breadcrumbsData = this.breadcrumbsData.map((breadCrumb, index) => {
        const item = {
          "@type": "ListItem",
          "position": index + 1,
          "name": breadCrumb.name,
        };

        if (index !== this.breadcrumbsData.length -1) {
          item.item = baseUrl + breadCrumb.url
        }

        return item;
      })

      scriptElement.innerHTML = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbsData
      }, null, 2);
    },
    makeBreadCrumbsData() {
      const newBreadCrumbsData = [
        {
          name: 'Discover',
          url: '/discover'
        }
      ];
      if (this.countryName && !this.cityName.length) {
        newBreadCrumbsData.push({
          name: this.countryName,
          url: `/discover/${this.countrySlug}`,
        })
      }
      if (this.cityName.length) {
        newBreadCrumbsData.push({
          name: this.cityName.join(', '),
          url: this.makeUrl('city', this.cityName.length <= 0)
        })
      }

      if (this.artType.length) {
        newBreadCrumbsData.push({
          name: this.artType.join(', '),
          url: this.makeUrl('art_type', this.cityName.length <= 0)
        })
      }
      if (this.speciality.length) {
        newBreadCrumbsData.push({
          name: this.speciality.join(', '),
          url: this.makeUrl('speciality', this.cityName.length <= 0)
        })
      }
      if (this.genre.length) {
        newBreadCrumbsData.push({
          name: this.genre.join(', '),
          url: this.makeUrl('genre', this.cityName.length <= 0)
        })
      }

      this.breadcrumbsData = newBreadCrumbsData;
      this.updateSchema();
    }
  }
}

</script>

<template>
  <div class="discover-breadcrumbs">
    <span
      v-for="(breadcrumb, index) in breadcrumbsData"
      :key="breadcrumb.name"
    >
      <a :href="breadcrumb.url" v-if="index !== breadcrumbsData.length - 1">{{ breadcrumb.name}}</a>
      <span v-if="index === breadcrumbsData.length - 1">{{ breadcrumb.name}}</span>
    </span>
  </div>
</template>